import Navbar from "../components/Navbar/Navbar";
import {Outlet} from "react-router-dom";
import React from "react";

const PublicLayout = () => (
    <>
        <Navbar></Navbar>
        <div className='layout'>
            <Outlet />
        </div>
    </>
);
export default PublicLayout;